/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApiUserDataFromJSON, ApiUserDataToJSON, } from "./ApiUserData";
/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value) {
    if (!("userdata" in value) || value.userdata === undefined)
        return false;
    return true;
}
export function UserFromJSON(json) {
    return UserFromJSONTyped(json, false);
}
export function UserFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        userdata: ApiUserDataFromJSON(json.userdata),
    };
}
export function UserToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        userdata: ApiUserDataToJSON(value.userdata),
    };
}
